import { Layout } from 'antd';
import styled from 'styled-components';

const { Header } = Layout;

export const StyledHeader = styled(Header)`
	position: fixed;
	align-items: center;
	background-color: #fff;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .078);
	display: flex;
	justify-content: space-between;
	height: 58px;
	padding-left: 24px;
	padding-right: 28.28px;
	position: -webkit-sticky;
	position: sticky;
	right: 0;
	top: 0;
	width: 100%;
	z-index: 102;
  ${({ theme }) =>
    theme.media.monitor(
      `
       height: 70px;
       padding: 0px 60px;
      `,
    )}
  ${({ theme }) =>
    theme.media.mobile(
      `
       padding: 0px 22px;
      `,
    )}
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  height: 100%;
`;

export const Logo = styled.img`
  width: 145px;
  height: auto;
  :hover {
    cursor: pointer;
  }  
  ${({ theme }) =>
    theme.media.monitor(
      `
        width: 160px;
      `,
    )}
  ${({ theme }) =>
    theme.media.mobile(
      `
       width: 70px;
       margin: inherit;
      `,
    )}
`;


export const UserInfo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  height: 70%;
  padding: 0 15px 0 5px;
  border-radius: 10px;
  font-weight: 400;
  color: black;
  white-space: nowrap;
  font-size: 16px;

  :hover {
    cursor: pointer;
  }    
  ${({ theme }) =>
      theme.media.monitor(
        `
          font-size: 22px;
        `,
    )}
  ${({ theme }) =>
    theme.media.mobile(
      `
       font-size: 12px;
       padding: 0px;
      `,
    )}  
`;
